<template>
  <router-view/>
</template>

<script>

export default {
  name: 'RequestsMain'
}
</script>
